// @flow
import React from 'react';
import {
  defineMessages,
  injectIntl,
  FormattedMessage,
  type IntlShape,
} from 'react-intl';
import ButtonLink from 'brastrap/common/button-link/ButtonLink';
import Link from 'brastrap/containers/link/LinkContainer';

type Props = {
  intl: IntlShape,
  onClick: (SyntheticEvent<HTMLAnchorElement>) => void,
};

const messages = defineMessages({
  button: {
    id: 'help-chat.button',
    defaultMessage: 'Start live chat',
  },
  helpNumber: {
    id: 'help-chat.number',
    defaultMessage: '01926 459 859',
  },
});

const Chat = ({ intl: { formatMessage }, onClick }: Props) => {
  const helpNumber = formatMessage(messages.helpNumber);
  return (
    <section className="c-chat">
      <h1 className="c-chat__title">
        <FormattedMessage
          id="help-chat.title"
          defaultMessage="Prefer to talk to someone?"
        />
      </h1>
      <p>
        <span className="c-chat__desc">
          <FormattedMessage
            id="chat-cta"
            defaultMessage="Call"
            values={{ number: helpNumber }}
          />
          <strong>
            <Link href={`tel:${helpNumber}`}>{helpNumber}</Link>
          </strong>
        </span>
        <span className="c-chat__or">
          <FormattedMessage id="chat-or" defaultMessage="or" />
        </span>
        <ButtonLink
          label={formatMessage(messages.button)}
          url="/chat/"
          linkType="to"
          onClick={onClick}
        />
      </p>
    </section>
  );
};

Chat.defaultProps = {
  onClick: () => {},
};

export default injectIntl(Chat);
